import { baseUrl } from '../app/constants';
import defaultAvatar from '../assets/images/user.svg';

export const avatarLink = (avatarId: string) => {
  return avatarId && avatarId !== '00000000-0000-0000-0000-000000000000'
    ? `${baseUrl}api/Person/avatarImage?avatarId=${avatarId}`
    : defaultAvatar;
};

export const convertToTimeMask = (secs: number | string) => {
  secs = typeof secs === 'string' ? parseFloat(secs) : secs;
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor(secs / 60) % 60;
  const seconds = secs % 60;

  return (
    [hours, minutes, seconds.toFixed(2)]
      .map((v) => (v < 10 ? '0' + v : v))
      // .filter((v, i) => v !== '00' || i > 0)
      .join(':')
  );
};

export const convertFromTimeMaskToSec = (mask: string | undefined | number) => {
  if (
    parseFloat((mask || '').toString()).toString() === (mask || '').toString()
  ) {
    return parseFloat((mask || '').toString());
  }
  let [hours, minutes, seconds] = (mask || '').toString().split(':');
  return (
    (parseFloat(hours) || 0) * 3600 +
    (parseFloat(minutes) || 0) * 60 +
    (parseFloat(seconds) || 0)
  );
};
